import {
  WSButton,
  WSElement,
  WSInfoBox,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { useState } from "react";
import type {
  AuditLogResource,
  ListAuditLogsFilterParameterResourceTypeEq
} from "@wingspanhq/wingspan-api-sdk";
import { EventContent } from "./EventContent";
import { pluralizeEventTitle } from "./pluralizeEventTitle";
import { EventGroup } from "./types";

type Props = {
  group: EventGroup & { type: "grouped" };
  drillDownResourceType?: ListAuditLogsFilterParameterResourceTypeEq;
  onDrillDown?: (resource: AuditLogResource) => void;
};

export const EventGroupContent: React.FC<Props> = props => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <WSElement>
      <WSText.ParagraphSm color="gray600">
        {pluralizeEventTitle(props.group.eventTitle, props.group.events.length)}
      </WSText.ParagraphSm>

      {isExpanded ? (
        <>
          <WSInfoBox mt="M">
            <WSList gap="M">
              {props.group.events.map(event => (
                <WSElement key={event.id}>
                  <EventContent
                    event={event}
                    drillDownResourceType={props.drillDownResourceType}
                    onDrillDown={props.onDrillDown}
                  />
                </WSElement>
              ))}
            </WSList>
          </WSInfoBox>
          <WSButton.Link
            size="S"
            ml="NONE"
            pl="NONE"
            mt="S"
            onClick={() => setIsExpanded(false)}
          >
            See less
          </WSButton.Link>
        </>
      ) : (
        <WSButton.Link
          size="S"
          ml="NONE"
          pl="NONE"
          onClick={() => setIsExpanded(true)}
        >
          See more
        </WSButton.Link>
      )}
    </WSElement>
  );
};
